<template>

    <div id="documents-view">
        <document-set-header v-bind:document-set="store.data.currentDocumentSet"></document-set-header>
        <div class="row sharing-row" v-if="sharingEnabled">
            <div class="col-xs-4 manage-users-controls">
                <router-link :to="{ name: 'DocumentsInvitations' }" class="btn btn-primary">
                    <i class="fa fa-user"></i> Users
                </router-link>
            </div>
            <div class="col-xs-8 document-select-controls">
                <button v-if="!selected" disabled class="btn"><i class="fa fa-share"></i> Share selected</button>
                <router-link :to="{ name: 'DocumentsShare' }" v-if="selected" class="btn btn-primary">
                    <i class="fa fa-share"></i> Share {{ selected }} document<span v-if="selected != 1">s</span>
                </router-link>
            </div>
        </div>
        <div class="row" v-for="docs, category in sortedDocuments">
            <div class="col-xs-12 document-group data-item">
                <h3 class="document-group-title">{{ category }}</h3>
                <document-item v-for="doc in docs" :key="doc.id" :document.sync="doc" :sharingEnabled="sharingEnabled"></document-item>
            </div>
        </div>
    </div>

</template>



<script>

    import DocumentItem from '@/components/DocumentItem'
    import DocumentSetHeader from '@/components/DocumentSetHeader'
    import DocumentSetsService from '@/services/document-sets.service'
    import { Store } from '@/store.js'

    export default {

        name: 'documentsView',

        props: [],

        data() {
            return {
                sortedDocuments: {},
                store: Store
            }
        },

        computed: {
            selected: function() {
                var selectedCount = 0
                if (!this.store.data.currentDocumentSet.documents) {
                    return 0
                }
                for (var i = 0; i < this.store.data.currentDocumentSet.documents.length; i++) {
                    if (this.store.data.currentDocumentSet.documents[i].selected) {
                        selectedCount++
                    }
                };
                return selectedCount
            },
            setType: function() {
                return this.$route.params.setType
            },
            sharingEnabled: function() {
                return this.setType=='owneddocumentsets'
            },
            setId: function() { return this.$route.params.setId; },
            setType: function() { return this.$route.params.setType; }

        },

        components: {
            'document-item': DocumentItem,
            'document-set-header': DocumentSetHeader
        },

        created: function() {
            this.requestDocumentSet(this.setId, this.setType)
        },

        methods: {

            requestDocumentSet: function(setId, setType) {
                DocumentSetsService.getSet(setId, setType)
                    .then(use.bind(this));

                function use(set) {
                    this.store.data.currentDocumentSet = set
                    this.sortedDocuments = DocumentSetsService.categorizeSet(set)
                    return set;
                }
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    #documents-view:after {
        content: "";
        display: table;
        clear: both;
    }

    .manage-users-controls {
        text-align: left;

        .btn {
           font-size: 1rem;
        }
    }

    .document-select-controls {
        text-align: right;

        .btn {
           font-size: 1rem;
        }
    }

    .document-group {
        text-align: left;

        h3 {
            margin: 0 0 1rem 0;
            font-weight: bold;
        }
    }

    .sharing-row {
        margin-bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// DocumentsView.vue?2fcb41c2